export const ROUTES = {
	home: '/',
	login: '/login',
	loginSSO: '/login-sso',
	register: '/register',
	config: '/',

	//auth
	studentCalendar: '/student-calendar',
	tutoringGrades: '/consultar-notas-tutoria',
	homeStudent: '/home-student',
	homeTeacher: '/home-teacher',
	selectModule: '/select-module',
	TutorNotes: '/tutor-notes',
	problemHistory: '/problem-history',
	teacherLaunchNotes: '/professor-lancar-notas',
	noteRelease: '/note-release',
	LaunchMorphofunctionalNotes: '/launch-morphofunctional-notes',
	reportsPage: '/reports-page',
	inconsistencies: '/inconsistencies',
	consultPerformanceMentoringProgress: '/consult-performance-mentoring-progress',
	registerEvaluation: '/register-evaluation',
	throwCognitiveNotes: '/throw-cognitive-notes',
	parameterizeProblem: '/parameterize-problem',
	generalNotes: '/general-notes',
	generalMorfo: '/general-notes-morfo',
	accessDenied: '/access-denied',
	consultNotes: '/consult-notes',
	professorSelectPerlet: '/select-perlet',
};
